import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "promo-page" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<span id=\"promo-page-background\"><img src=\"https://seattleyachtmedia.b-cdn.net/seattle.png\" alt=\"../assets/seattle.png\"></span><a href=\"https://www.seattleyachtmedia.com/#/\"><div id=\"page-logo\"><img src=\"https://seattleyachtmedia.b-cdn.net/text-logo.png\" alt=\"../assets/text-logo.png\"></div></a><div id=\"image-box-row\"><div class=\"image-boxes\"><a href=\"https://www.youtube.com/watch?v=hXu5N5_KzGU\" target=\"_blank\" class=\"promo-image-box\"></a><a href=\"https://www.youtube.com/watch?v=xBaTvwYiwtI&amp;t=2s\" target=\"_blank\" class=\"promo-image-box\"></a><a href=\"https://www.youtube.com/watch?v=xBaTvwYiwtI&amp;t=2s\" target=\"_blank\" class=\"promo-image-box\"></a></div></div>", 3)
const _hoisted_5 = { class: "promo-text-container" }
const _hoisted_6 = { class: "promo-text" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.facebook.com/people/Seattle-Yacht-Media/100070387113379/?paipv=0&eav=AfYVhKY3RYg0WB43LbE1VEzzCWfVAgkpbzd2X0dWXieiUl_7THUEtOg4DWp3E00Tmp8&_rdr",
  class: "fa fa-facebook"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.instagram.com/seattleyachtmedia/",
  target: "_blank",
  class: "fa fa-instagram"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.youtube.com/channel/UCU7PhHxisyz2ipQZ1p6G-Hg",
  class: "fa fa-youtube"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://www.linkedin.com/company/seattle-yacht-media/",
  class: "fa fa-linkedin"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactCard3 = _resolveComponent("ContactCard3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(" adventures are how "),
        (_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("br", _hoisted_7))
          : _createCommentVNode("", true),
        _createTextVNode(" we make our moments "),
        _hoisted_8,
        _createTextVNode(" stories are how we share them ")
      ])
    ]),
    _createVNode(_component_ContactCard3),
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    _hoisted_12
  ]))
}